export default
{
    "tablePosition": "player2",
    "background": { x: 0, y: 0, width: 800, height: 500 },
    "hand2": { x: 340 + 50, y: 350 + 70, r: 0, offsetX: 101, offsetY: 0, selectedOffsetY: -20, maxWidth: 360, width: 100, height: 140, offsetR: 0, showfront: false, pileStyle: "center" },
    "hand1": { x: 340 + 50, y: 10 + 70, r: 0, offsetX: 101, offsetY: 0, selectedOffsetY: -5, maxWidth: 360, width: 100, height: 140, offsetR: 0, showfront: true, randomZOrder: true, pileStyle: "center" },
    "handShow2": { x: 340 + 50, y: 350 + 70, r: 0, offsetX: 101, offsetY: 0, maxWidth: 360, width: 100, height: 140, offsetR: 0, showfront: false, pileStyle: "center" },
    "handShow1": { x: 340 + 50, y: 10 + 70, r: 0, offsetX: 101, offsetY: 0, maxWidth: 360, width: 100, height: 140, offsetR: 0, showfront: false, pileStyle: "center" },
    "cribShow1": { x: 340 + 50, y: 180 + 70, r: 0, offsetX: 101, offsetY: 0, maxWidth: 360, width: 100, height: 140, offsetR: 0, showfront: false, pileStyle: "center" },
    "cribShow2": { x: 340 + 50, y: 180 + 70, r: 0, offsetX: 101, offsetY: 0, maxWidth: 360, width: 100, height: 140, offsetR: 0, showfront: false, pileStyle: "center" },
    "cribstaging1": { x: 525, y: 250, offsetX: -70, offsetY: 0, showfront: true, pileStyle: "basic"},
    "cribstaging2": { x: 260, y: 250, offsetX: 70, offsetY: 0, showfront: false, pileStyle: "basic" },
    "crib2": { x: 165, y: 360, r: 0, offsetX: 2, offsetY: 1, scale: 0.2, showfront: true, pileStyle: "basic" },
    "crib1": { x: 165, y: 20, r: 0, offsetX: 2, offsetY: 1, scale: 0.2, showfront: true, pileStyle: "basic" },
    "play": { x: 205 + 50, y: 180 + 70 + 2, offsetX: 30, offsetY: 0, pileStyle: "staggard", staggerY: -6, staggerPlayer: "player1", mergePile: "played", offsetXMergedPile: 20, offsetXGap: 80 },
    "playBackground": { x: 205, y: 180, width: 300, height: 140 },
    "played": { grayedOut: true },
    "deck": { x: 130, y: 250, offsetX: 0.1, offsetY: -0.1, width: 100, height: 140, pileStyle: "basic" },
    "cut": { x: 130, y: 250, offsetX: 8, offsetY: 0, pileStyle: "basic" },
    "cut2": { x: 400, y: 420, offsetX: 2, offsetY: 0, pileStyle: "basic" },
    "cut1": { x: 400, y: 80, offsetX: 2, offsetY: 0, pileStyle: "basic"},
    "cribbageboard": { x: 600, y: 0, width: 200, height: 500 },
    "confirm": { x: 265, y: 220 },
    "playcount": { x: 560, y: 180 + 40 },
    "profile2": { x: 80, y: 350 },
    "profile1": { x: 80, y: 10 },
    "chatBubble2": { x: 80 + 80, y: 330 },
    "chatBubble1": { x: 80 + 80, y: 30 },
    "instructions2": { x: 385, y: 325 },
    "instructions1": { x: 385, y: 155 },
    "invalidMove2": { x: 400, y: 485 },
    "invalidMove1": { x: 400, y: -15 },
    "pointPopup2": { x: 400, y: 350 + 60 },
    "pointPopup1": { x: 400, y: 10 + 60 },
};